import { environment } from '../../../../environments/environment';
import { UICommand } from '../../base-components/ui-command';
import { LayoutActions, LayoutActionTypes } from './layout.actions';

export interface LayoutState {
    title: string;
    commands: UICommand[];
    isMain: boolean;
}

const initialState: LayoutState = {
    title: environment.appName,
    commands: [],
    isMain: true
};

export function layoutReducer(state = initialState, action: LayoutActions): LayoutState {
    switch (action.type) {
        case LayoutActionTypes.SetContainer: {

            return {
                isMain: action.isMain,
                commands: action.commands,
                title: action.title
            };
        }

        case LayoutActionTypes.SetTitle: {

            return {
                ...state,
                title: action.title
            };
        }
        default:
            return state;
    }
}
